import { render, staticRenderFns } from "./PrintCatalog.vue?vue&type=template&id=6aa242b5&scoped=true&"
import script from "./PrintCatalog.vue?vue&type=script&lang=js&"
export * from "./PrintCatalog.vue?vue&type=script&lang=js&"
import style0 from "./PrintCatalog.vue?vue&type=style&index=0&id=6aa242b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa242b5",
  null
  
)

export default component.exports